import api from '@/api/api';

const resource = `v1/projetos`;

export default {
  getAll(clientId) {
    return api.get(`${resource}/${clientId}/enquadrados`);
  }
}